var _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusicOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 5.2916669 6.6145836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1095",
    transform: "matrix(1.1802891,0,0,1.1936117,-114.20096,-131.02096)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.25,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect18071",
    width: 4.2333331,
    height: 5.2916665,
    x: 96.883331,
    y: 109.89204
  }), /*#__PURE__*/React.createElement("g", {
    id: "g53343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18111",
    style: {
      fill: "#343434",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: 0.25,
      strokeLinecap: "square",
      strokeOpacity: 1
    },
    d: "m 98.317878,113.84786 a 0.19605745,0.32676244 59.828506 0 1 -0.183962,0.33372 0.19605745,0.32676244 59.828506 0 1 -0.381026,-0.005 0.19605745,0.32676244 59.828506 0 1 0.183956,-0.33373 0.19605745,0.32676244 59.828506 0 1 0.381032,0.005 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: "0.264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 98.317878,113.84786 v -1.67274 l 1.101924,-0.6362 v 1.75804",
    id: "path18248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse18339",
    style: {
      fill: "#343434",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: 0.25,
      strokeLinecap: "square",
      strokeOpacity: 1
    },
    d: "m 99.433797,113.25796 a 0.19605745,0.32676244 59.828506 0 1 -0.183957,0.33373 0.19605745,0.32676244 59.828506 0 1 -0.381032,-0.005 0.19605745,0.32676244 59.828506 0 1 0.183956,-0.33373 0.19605745,0.32676244 59.828506 0 1 0.381033,0.005 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicOff);
export default __webpack_public_path__ + "static/media/music_off.43abfe03edf399c7d1bc482407e4ac8b.svg";
export { ForwardRef as ReactComponent };